import { render, staticRenderFns } from "./DoctorReportPromoBanner.vue?vue&type=template&id=a906bc3e&scoped=true"
import script from "./DoctorReportPromoBanner.vue?vue&type=script&lang=ts"
export * from "./DoctorReportPromoBanner.vue?vue&type=script&lang=ts"
import style0 from "./DoctorReportPromoBanner.vue?vue&type=style&index=0&id=a906bc3e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a906bc3e",
  null
  
)

export default component.exports